// 打分页面
import React, { useState, useCallback } from "react";
import { useHistory } from "react-router";
import copy from "copy-to-clipboard";
import {
  Steps,
  NavBar,
  Icon,
  List,
  SegmentedControl,
  Button,
  Progress,
  Toast,
} from "antd-mobile";
import Result from "./Result";
import styled from "styled-components";

const { Step } = Steps;

export default function ScoreWord() {
  const history = useHistory();
  // 顶部标题
  const [title, setTitle] = useState<string>("NMIBC计算器");
  // 定义进度状态
  const [current, setCurrent] = useState<number>(0);
  // 复发影响评分数组
  const [recurrenceRate, setRecurrenceRate] = useState<number[]>([]);
  // 进展影响评分数组
  const [progressRate, setProgressRate] = useState<number[]>([]);
  // 复发影响评分
  const [recurrenceScore, setRecurrenceScore] = useState<number>(0);
  // 进展影响评分
  const [progressScore, setProgressScore] = useState<number>(0);
  // 将肿瘤项目选项重置默认
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  // 将肿瘤大小选项重置默认
  const [selectedIndex1, setSelectedIndex1] = useState<number>(-1);
  // 将复发率选项重置默认
  const [selectedIndex2, setSelectedIndex2] = useState<number>(-1);
  // 将分期选项重置默认
  const [selectedIndex3, setSelectedIndex3] = useState<number>(-1);
  // 将分级选项重置默认
  const [selectedIndex4, setSelectedIndex4] = useState<number>(-1);
  // 将伴发原为癌选项重置默认
  const [selectedIndex5, setSelectedIndex5] = useState<number>(-1);
  // 将极高危因素选项重置默认
  // const [selectedIndex6, setSelectedIndex6] = useState<number>(-1);
  // 肿瘤类型
  const [tumourType, setTumourType] = useState<string>("");
  // 复发结果组合数组
  const [optionGroup, setOptionGroup] = useState<number[]>([]);

  // 进度条数组值
  const [valueArr, setValueArr] = useState<number[]>();

  // 选择肿瘤项目
  const onTumourChange = useCallback(
    (e: any) => {
      setSelectedIndex(e.nativeEvent.selectedSegmentIndex);
      optionGroup[0] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex]
  );

  const onTumourValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "单发":
          score1 = 0;
          score2 = 0;
          break;
        case "2-7个":
          score1 = 3;
          score2 = 3;
          break;
        default:
          score1 = 6;
          score2 = 3;
      }
      recurrenceRate[0] = score1;
      progressRate[0] = score2;
    },
    [progressRate, recurrenceRate]
  );

  // 肿瘤大小选择
  const onTumourSizeChange = useCallback(
    (e: any) => {
      setSelectedIndex1(e.nativeEvent.selectedSegmentIndex);
      optionGroup[1] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex1]
  );

  const onTumourSizeValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "＜3cm":
          score1 = 0;
          score2 = 0;
          break;
        default:
          score1 = 3;
          score2 = 3;
      }
      recurrenceRate[1] = score1;
      progressRate[1] = score2;
    },
    [progressRate, recurrenceRate]
  );

  // 年复发率
  const onRateChange = useCallback(
    (e: any) => {
      setSelectedIndex2(e.nativeEvent.selectedSegmentIndex);
      optionGroup[2] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex2]
  );

  const onRateValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "原发":
          score1 = 0;
          score2 = 0;
          break;
        case "≤1次复发/年":
          score1 = 2;
          score2 = 2;
          break;
        default:
          score1 = 4;
          score2 = 2;
      }
      recurrenceRate[2] = score1;
      progressRate[2] = score2;
    },
    [progressRate, recurrenceRate]
  );

  // 分期
  const onInstalmentChange = useCallback(
    (e: any) => {
      setSelectedIndex3(e.nativeEvent.selectedSegmentIndex);
      optionGroup[3] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex3]
  );

  const onInstalmentValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "Ta":
          score1 = 0;
          score2 = 0;
          break;
        default:
          score1 = 1;
          score2 = 4;
      }
      recurrenceRate[3] = score1;
      progressRate[3] = score2;
    },
    [progressRate, recurrenceRate]
  );

  // 分级
  const onLeavelChange = useCallback(
    (e: any) => {
      setSelectedIndex4(e.nativeEvent.selectedSegmentIndex);
      optionGroup[4] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex4]
  );

  const onLeavelValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "G1":
          score1 = 0;
          score2 = 0;
          break;
        case "G2":
          score1 = 1;
          score2 = 0;
          break;
        default:
          score1 = 2;
          score2 = 5;
      }
      recurrenceRate[4] = score1;
      progressRate[4] = score2;
    },
    [progressRate, recurrenceRate]
  );

  // 伴发原位癌
  const onConcomitantChange = useCallback(
    (e: any) => {
      setSelectedIndex5(e.nativeEvent.selectedSegmentIndex);
      optionGroup[5] = e.nativeEvent.selectedSegmentIndex;
    },
    [selectedIndex5]
  );

  const onConcomitantValueChange = useCallback(
    (value: string) => {
      let score1 = 0; //复发评分项目
      let score2 = 0; //进展评分项目
      switch (value) {
        case "无":
          score1 = 0;
          score2 = 0;
          break;
        default:
          score1 = 1;
          score2 = 6;
      }
      recurrenceRate[5] = score1;
      progressRate[5] = score2;
    },
    [progressRate, recurrenceRate]
  );

  //是否伴发极高危因素
  // const onReasonChange = useCallback(
  //   (e: any) => {
  //     setSelectedIndex6(e.nativeEvent.selectedSegmentIndex);
  //     optionGroup[6] = e.nativeEvent.selectedSegmentIndex;
  //   },
  //   [selectedIndex6]
  // );

  //计算
  const onComputed = () => {
    if (optionGroup.length === 0) {
      Toast.info("请选择选项！");
      return;
    }
    if (optionGroup.length < 6) {
      Toast.info("有选项未选择，请继续选择！");
      return;
    }

    recurrenceRate.length > 0
      ? setRecurrenceScore(
          recurrenceRate.reduce((pre, cur) => {
            return pre + cur;
          })
        )
      : setRecurrenceScore(0);

    progressRate.length > 0
      ? setProgressScore(
          progressRate.reduce((pre, cur) => {
            return pre + cur;
          })
        )
      : setProgressScore(0);

    // 判断肿瘤类型
    if (
      // selectedIndex6 !== -1 ||
      selectedIndex1 !== 0 &&
      selectedIndex3 === 1 &&
      selectedIndex4 === 2 &&
      (selectedIndex > -1 || selectedIndex2 > 0 || selectedIndex5 || -1)
    ) {
      setTumourType("极高危肿瘤!!!");
    } else if (
      selectedIndex3 === 1 ||
      selectedIndex4 === 2 ||
      selectedIndex5 === 0 ||
      (selectedIndex > 0 &&
        selectedIndex1 > 0 &&
        selectedIndex2 > 0 &&
        selectedIndex3 === 0 &&
        selectedIndex4 > -1 &&
        selectedIndex4 < 2) ||
      (selectedIndex === 0 &&
        selectedIndex1 === 0 &&
        selectedIndex2 === 0 &&
        selectedIndex3 === 1 &&
        selectedIndex4 === 2 &&
        selectedIndex5 === 0) ||
      (selectedIndex > 0 &&
        selectedIndex1 > 0 &&
        selectedIndex2 > 0 &&
        selectedIndex3 === 0 &&
        selectedIndex4 > -1 &&
        selectedIndex4 < 2) ||
      (selectedIndex === 0 &&
        selectedIndex1 === 0 &&
        selectedIndex2 === 0 &&
        selectedIndex3 === 1 &&
        selectedIndex4 === 2 &&
        selectedIndex5 === 1)
    ) {
      setTumourType("高危肿瘤!!");
    } else if (
      selectedIndex === 0 &&
      selectedIndex1 === 0 &&
      selectedIndex2 === 0 &&
      selectedIndex3 === 0 &&
      selectedIndex4 === 0 &&
      selectedIndex5 === 1
    ) {
      setTumourType("低危肿瘤");
    } else {
      setTumourType("中危肿瘤!");
    }

    // 子组件进度条接收值
    const value1 =
      recurrenceRate.length > 0
        ? recurrenceRate.reduce((pre, cur) => {
            return pre + cur;
          })
        : 0;
    const value2 =
      progressRate.length > 0
        ? progressRate.reduce((pre, cur) => {
            return pre + cur;
          })
        : 0;
    setValueArr([value1, value2]);
    setCurrent(1);
    setTitle("结果");
  };

  // 重新计算
  const onReComputed = () => {
    setCurrent(0); //返回上一步
    setSelectedIndex(-1); //选择项重置
    setSelectedIndex1(-1);
    setSelectedIndex2(-1);
    setSelectedIndex3(-1);
    setSelectedIndex4(-1);
    setSelectedIndex5(-1);
    // setSelectedIndex6(-1);
    setRecurrenceRate([]); //进度区间重置
    setProgressRate([]);
    setTumourType(""); //重置传递类型
    setOptionGroup([]); //清空重置组合数组
    setValueArr([]); //重置传递数组
    setTitle("NMIBC计算器");
  };

  // 复制链接
  const onCopyHref = () => {
    const baseUrl = "http://mobile.react.tysoft.com";
    // const baseUrl = "http://localhost:3000";
    const copyHref = `${baseUrl}/doctor/result/${JSON.stringify(
      valueArr
    )}/${encodeURI(tumourType)}`;
    if (copyHref !== "") {
      copy(copyHref);
      Toast.info("链接已复制");
    } else {
      Toast.info("复制失败!请重新复制");
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <img
        src="/doctorApp/bg.png"
        style={{
          position: "absolute",
          zIndex: 1,
          top: 0,
          width: "100vw",
          height: "100vh",
        }}
      />
      <ScoreWordBox>
        <NavBar
          style={{
            width: "100%",
            height: "7%",
            // background: "white",
            background: "transparent",
            color: "white",
            fontWeight: "bold",
            position: "fixed",
            top: 0,
            zIndex: 10,
            backgroundColor: "rgb(23,140,162)",
          }}
          icon={
            <Icon
              type="left"
              onClick={() => {
                if (title === "结果") {
                  setCurrent(0);
                  setTitle("NMIBC计算器");
                } else {
                  history.go(-1);
                }
              }}
            />
          }
        >
          {title}
        </NavBar>
        <div className="processStatus">
          <Steps current={current} direction="horizontal">
            <Step title="提交信息" />
            <Step title="得出结果" />
          </Steps>
          <h3
            style={{
              textAlign: "center",
              color: "white",
              fontSize: 18,
              margin: "5px 0 0 0",
            }}
          >
            非肌层浸润性膀胱癌(NMIBC)复发和进展计算器
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          {/* 项目打分 */}
          {current === 0 ? (
            <div className="itemScore">
              <List>
                <List.Item>
                  <span className="itemName">肿瘤项目</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex}
                    values={["单发", "2-7个", "≥8"]}
                    onChange={onTumourChange}
                    onValueChange={onTumourValueChange}
                  />
                </List.Item>
                <List.Item>
                  <span className="itemName">肿瘤大小</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex1}
                    values={["＜3cm", "≥3cm"]}
                    onChange={onTumourSizeChange}
                    onValueChange={onTumourSizeValueChange}
                  />
                </List.Item>
                <List.Item>
                  <span className="itemName">既往复发率</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex2}
                    values={["原发", "≤1次复发/年", "＞1次复发/年"]}
                    onChange={onRateChange}
                    onValueChange={onRateValueChange}
                  />
                </List.Item>
                <List.Item>
                  <span className="itemName">分期</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex3}
                    values={["Ta", "T1"]}
                    onChange={onInstalmentChange}
                    onValueChange={onInstalmentValueChange}
                  />
                </List.Item>
                <List.Item>
                  <span className="itemName">分级</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex4}
                    values={["G1", "G2", "G3"]}
                    onChange={onLeavelChange}
                    onValueChange={onLeavelValueChange}
                  />
                </List.Item>
                <List.Item>
                  <span className="itemName">伴发原位癌</span>
                  <SegmentedControl
                    className="options"
                    selectedIndex={selectedIndex5}
                    values={["有", "无"]}
                    onChange={onConcomitantChange}
                    onValueChange={onConcomitantValueChange}
                  />
                </List.Item>
                {/* <List.Item>
                <span className="itemName">《是否伴发极高危因素》</span>
                <SegmentedControl
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: 160,
                  }}
                  selectedIndex={selectedIndex6}
                  className="reasonOptions"
                  values={[
                    "前列腺尿道cis",
                    "几个尿道上皮癌组织学变异性",
                    "淋巴管浸润",
                    "BCG治疗失败",
                  ]}
                  onChange={onReasonChange}
                />
              </List.Item> */}
              </List>
            </div>
          ) : (
            <>
              <Result value={valueArr} tumourType={tumourType} />
            </>
          )}
          {/* 底部按钮 */}
          {current === 0 ? (
            <Button
              type="primary"
              style={{
                margin: "10px auto",
                width: "98%",
              }}
              onClick={() => onComputed()}
            >
              计算
            </Button>
          ) : (
            <div className="btnGroup">
              <Button onClick={() => onReComputed()} className="btn">
                重新计算
              </Button>
              <Button onClick={() => onCopyHref()} className="btn">
                复制结果
              </Button>
            </div>
          )}
        </div>
      </ScoreWordBox>
    </div>
  );
}

const ScoreWordBox = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  z-index: 2;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .processStatus {
    padding: 10px 0;
    margin-top: 15%;
  }
  .itemName {
    font-size: 14px;
  }
  .itemScore {
    height: 84%;
    background: white;
  }
  .options {
    margin-top: 5px;
    height: 35px;
  }
  .reasonOptions {
    margin-top: 5px;
    height: 35px;
  }
  .reasonOptions .am-segment-item {
    border-radius: 5px;
    margin-bottom: 5px;
    border-left-width: 1px;
  }
  .progress {
    height: 40px;
    // background-color: orange;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5px;
    margin-bottom: 10px;
  }
  .btnGroup {
    display: flex;
    flex: 1;
    padding: 0 14px;
    justify-content: space-between;
    margin-bottom: 21px;
  }
  .btn {
    width: 48%;
    height: 46px;
    border-radius: 2px;
    background-color: #15869b;
    border: 1px solid #d6f7ff;
    color: white;
  }
  .am-icon {
    width: 30px;
    height: 30px;
  }
  .am-steps-item-title {
    color: white;
  }
  .am-navbar-title {
    font-size: 20px;
  }
  .am-steps-item-icon {
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 30px;
}
`;
